<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      >
        <template #[`item.project_name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">{{ item.project_name }}</div>
            </template>
            <span>Очереди: {{ item.queues }}</span>
          </v-tooltip>
        </template>
        <template #[`item.service_level`]="{ item }">
          <div class="colorfull_cell" :class="item.service_level >= item.project_service_level ? 'green' : 'red'">
            {{ item.service_level }}%({{ item.project_service_level }}%)
          </div>
        </template>
        <template #[`item.sl`]="{ item }">
          <div class="colorfull_cell" :class="item.sl >= item.project_sl ? 'green' : 'red'">
            {{ item.sl }}%({{ item.project_sl }}%)/{{ item.project_wait_time_sl }}с.
          </div>
        </template>
      </v-data-table>
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OksReport',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headers: [
          {text: 'Проект', value: 'project_name'},
          {text: 'Всего поступило', value: 'total_calls_count'},
          {text: 'Принятые', value: 'accepted_calls_count'},
          {text: 'Пропущенные < порогового значения', value: 'missed_calls_count_less_wait_time'},
          {text: 'Пропущенные > порогового значения', value: 'missed_calls_count_more_wait_time'},
          {text: 'Фактический сервис', value: 'service_level'},
          {text: 'SLA', value: 'sl', width: '135px'},
        ],
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadOksReportWidget: 'dashboard/loadOksReportWidget',
    }),

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadOksReportWidget(this.widget.params);
      this.isLoaded = true;
    },
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">
.colorfull_cell {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;

  &.green {
    background-color: #4CAF5040 !important;
  }
  &.red {
    background-color: #F4433640 !important;
  }
}
</style>